import request from '@/utils/request'

/**
 * 基础枚举接口
 * @param {*} params
 * @param {*} params.key 枚举key
 * @returns
 * @link https://yapi.jryghq.com/project/172/interface/api/30312
 */
export function getGovernanceCommonEnum(params) {
  return request({
    url: 'admin/v1/governance/engine/v1/enum/info',
    method: 'get',
    params
  })
}
